// SSE 실시간 이벤트 계약의 단일 출처(SSOT). api(emit)·web(구독/무효화)·desktop(SSE 릴레이)이
// 모두 이 패키지를 import해 이벤트명·terminal 상태를 한 곳에서만 정의한다. 한쪽만 바뀌면
// 타입/빌드가 깨지도록(런타임 드리프트 → 컴파일 타임 검출) 하기 위한 계약이다.
// core-constants와 동형: 빌드 스텝 없는 손작성 ESM 패키지(index.js + index.d.ts).

// 이벤트명 별칭 상수. 호출부가 문자열 리터럴 대신 이 상수를 참조하면 오타가 컴파일에서 잡힌다.
export const REALTIME_EVENT = Object.freeze({
  NOTIFICATION: 'notification',
  PLAN_UPDATED: 'plan.updated',
  COMPLETION_REPORT_UPDATED: 'completionReport.updated',
  POST_MORTEM_UPDATED: 'postMortem.updated',
  CO_ACTION_UPDATED: 'coAction.updated',
  CODE_REVIEW_UPDATED: 'codeReview.updated',
  DOCUMENT_UPDATED: 'document.updated',
  CONVENTION_UPDATED: 'convention.updated',
  DAEMON_TRIGGER_UPDATED: 'daemonTrigger.updated',
  SKILL_UPDATED: 'skill.updated',
  PROJECT_UPDATED: 'project.updated',
});

// web 구독(attach/detach)·핸들러 매핑이 단일 출처로 사용하는 이벤트명 카탈로그.
// 순서·값은 web/api/desktop 전반의 기존 정의와 바이트 단위로 동일하게 유지한다. 새 이벤트는 기존 목록 뒤에 덧붙인다.
export const REALTIME_EVENT_NAMES = [
  'notification',
  'plan.updated',
  'completionReport.updated',
  'postMortem.updated',
  'coAction.updated',
  'codeReview.updated',
  'document.updated',
  'convention.updated',
  'daemonTrigger.updated',
  'skill.updated',
  'project.updated',
];

export function isRealtimeEventName(value) {
  return typeof value === 'string' && REALTIME_EVENT_NAMES.includes(value);
}

// daemon 종료(terminal) 상태 집합. api `DaemonTriggerStatus`의 종료 상태 4종과 일치해야 하며,
// web 무효화(isTerminalDaemonStatus)가 `.has()`로 조회하므로 Set 형태로 export한다.
export const TERMINAL_DAEMON_TRIGGER_STATUSES = new Set(['DONE', 'CANCELLED', 'FAILED', 'REJECTED']);

// 탭 간 강제 로그아웃 안내의 허용 사유. 인증/권한 판단에는 사용하지 않는다.
// session_limit: 동시 로그인 세션 수 초과로 현재 세션이 FIFO 축출됨.
export const LOGOUT_REASON = Object.freeze({ SESSION_LIMIT: 'session_limit' });
export const isAllowedLogoutReason = (value) => Object.values(LOGOUT_REASON).includes(value);
